
import { Box } from "@mui/material";
import { t } from "i18next";
import * as React from "react";
import { useTranslation } from "react-i18next";
import CreateButton from "../../components/Admin/createButton";

import CommonContainer from "../../components/common/container/CommonContainer";
import ShopListRenderer from "../../components/Admin/list/ShopListRenderer";


const ShopList: React.FC = () => {
    const { t } = useTranslation('translation');

    return (
            <CommonContainer title={t("shopListingPageTitle")} description={t("shopListingPageDescription")}>
            <Box className="w-full" display="flex" flexDirection="row-reverse" justifyContent="flex-start">
                <CreateButton label={t("createShop")} path="/admin/createShop"/>
            </Box>
                <ShopListRenderer />
            </CommonContainer>
    );
};

export default ShopList;
